import { Spin, Modal, Tooltip } from 'antd'
import Button from 'components/Button'
import Control from 'components/Control/Control'
import AddIcon from 'components/icons/AddIcon'
import { SpinWrapper } from 'modules/Onboarding/Register/Education/style'
import CourseForm from 'modules/Resume/DrawerComponents/ProjectDetails/ProjectForm'
import React, { useEffect, useState } from 'react'

import { Form } from 'antd'
import { ExclamationCircleFilled } from '@ant-design/icons'
import styled from 'styled-components'
import { searchAPI, setResumeData } from 'modules/Onboarding/actions'
import {
  AdjustIcon,
  FooterFlex,
} from 'modules/Resume/DrawerComponents/DrawerStyle'
import { SubHeading1 } from 'modules/Resume/DrawerComponents/EducationDetailStyle'
import {
  ButtonLocal,
  Text,
} from 'modules/Resume/DrawerComponents/ProjectDetails/style'
import { useDispatch, useSelector } from 'react-redux'
import { searchConfig } from 'utils/config'
import ErrorMessage from 'utils/ErrorMessage'
import SuccessMessage from 'utils/SuccessMessage'
import { getListOfAllColleges, getStudentData } from '../../actions'
import instituteRequest from 'utils/instituteRequest'
import CrossIconSkill from 'components/icons/CrossIconSkill'
import { StyledDiv } from 'modules/Dashboard/Style/style'
import { FlexWrapRole } from 'modules/Roles/Style/style'

const CourseTrainingModal = ({
  drawerStatus,
  setdrawerStatus,
  updateStudentData,
  studentFormData,
  pendingData,
  getPendingData,
  listOfStudentSkills,
  setRoleDrawer,
  itemId,
  setLoading,
  roleDrawer = false,
  getEligibleDetails,
  getRoleFloatDetails,
  setExpDrawer,
  expDrawer,
  getListOfSkills,
}) => {
  const [form] = Form.useForm()
  const [course, setCourse] = useState([])
  const dispatch = new useDispatch()
  const [instituteCampusName, setInstituteCampusName] = useState('')
  const [organizationId, setOrganizationId] = useState('')
  const [isUpdateButtonEnabled, setIsUpdateButtonEnabled] = useState(true)
  const [skillLoading, setSkillLoading] = useState(false)
  const [listOfSkills, setListOfSkills] = useState([])
  const [updated, setUpdated] = useState(false)
  const [shown, setShown] = useState([])
  const [listOfAddedSkills, setListOfAddedSkills] = useState([])
  const [submitLoading, setSubmitLoading] = useState(false)
  const [tpoConfig, setTpoConfig] = useState(null)
  const [frozenFieldsMap, setFrozenFieldsMap] = useState({})
  const [isAddNewFrozen, setIsAddNewFrozen] = useState(false)

  const SkillsAPI = async (page, search) => {
    try {
      const results = await dispatch(
        searchAPI(searchConfig?.skills?.name, search, searchConfig?.skills)
      )
      let v = {
        name: search,
        id: Math.random().toString(36).substr(2, 8),
      }
      let updatedSkills = results || []
      if (updatedSkills?.length === 0 && search) {
        setListOfAddedSkills([...listOfAddedSkills, v])
        setListOfSkills([...updatedSkills, v])
      }
      const isExactMatch = updatedSkills?.some(
        skill => skill?.name.toLowerCase() === search?.toLowerCase()
      )
      if (updatedSkills?.length > 0) {
        if (!isExactMatch && search?.length > 3) {
          setListOfAddedSkills([...listOfAddedSkills, v])
          setListOfSkills([...updatedSkills, v])
        } else {
          setListOfSkills(updatedSkills)
        }
      }
    } catch (error) {
      console.error(`Error searching ${searchConfig?.skills?.name}:`, error)
    }
  }

  useEffect(() => {
    const fetchData = async () => {
      try {
        setSkillLoading(true)
        await SkillsAPI(0)
      } finally {
        setSkillLoading(false)
      }
    }

    fetchData()
  }, [])

  useEffect(() => {
    dispatch(getListOfAllColleges())
  }, [])

  useEffect(() => {
    const fetchTpoConfig = async () => {
      try {
        const instituteCampusId = studentFormData?.student?.instituteCampusId
        if (instituteCampusId) {
          const response = await instituteRequest.get(
            `/institutes/${instituteCampusId}/tpo-approval-config`
          )
          if (response?.data?.data) {
            setTpoConfig(response.data.data)
          }
        }
      } catch (error) {
        console.error('Error fetching TPO config:', error)
      }
    }
    fetchTpoConfig()
  }, [studentFormData?.student?.instituteCampusId])

  useEffect(() => {
    let config = tpoConfig
    if (!config || !config.tpoApprovalConfig || !config.tpoApprovalConfig.fields || !config.isRequestForTPOApproval) {
      setFrozenFieldsMap({})
      setIsAddNewFrozen(false)
      return
    }
    const frozen = {}
    const fields = config.tpoApprovalConfig.fields

    const certificationsAddNewConfig = fields['certifications.addNew']
    const coursesAddNewConfig = fields['courses.addNew']
    
    const approvedCourses = studentFormData?.resume?.courses || []
    
    const shouldFreezeAddNew = (certificationsAddNewConfig?.freezeAfterVerification || certificationsAddNewConfig?.freezeAfterApproval || coursesAddNewConfig?.freezeAfterVerification || coursesAddNewConfig?.freezeAfterApproval) && approvedCourses.length >= 1
    setIsAddNewFrozen(shouldFreezeAddNew)

    approvedCourses.forEach((course) => {
      if (!course.id) return

      const courseId = course.id
      frozen[courseId] = {}

      const courseFields = ['organization', 'title', 'started_in', 'ended_in', 'description', 'skill_set', 'certificate', 'credentialUrl']

      courseFields.forEach((field) => {
        const fieldMapping = {
          'organization': 'organisation',
          'title': 'title',
          'started_in': 'started_in',
          'ended_in': 'ended_in',
          'description': 'description',
          'skill_set': 'skill_set',
          'certificate': 'certificate',
          'credentialUrl': 'credentialUrl'
        }
        const mappedField = fieldMapping[field] || field
        const fullFieldName = `certifications.${mappedField}`
        const fieldConfig = fields[fullFieldName]

        if (fieldConfig && (fieldConfig.freezeAfterVerification || fieldConfig.freezeAfterApproval)) {
          const fieldValue = course[field]
          
          if (field === 'certificate' || field === 'started_in' || field === 'ended_in') {
            frozen[courseId][field] = true
          } else {
            const hasValue = fieldValue !== null && fieldValue !== undefined && fieldValue !== '' && 
                             (!Array.isArray(fieldValue) || fieldValue.length > 0)

            if (hasValue) {
              frozen[courseId][field] = true
              if (field === 'organization' && !frozen[courseId]['corporateId']) {
                frozen[courseId]['corporateId'] = true
              }
            }
          }
        }
      })
    })

    setFrozenFieldsMap(frozen)
  }, [tpoConfig, studentFormData?.resume?.courses])

  const AllCollegeList = useSelector(state => state?.resumeData?.AllCollegeList)

  useEffect(() => {
    let courseList = []
    
    const approvedCourses = studentFormData?.resume?.courses || []
    const pendingCourses = (pendingData && pendingData?.resume?.courses) || []
    
    const pendingMap = new Map()
    pendingCourses.forEach(pendingCourse => {
      if (pendingCourse.id || pendingCourse._itemId) {
        pendingMap.set(pendingCourse.id || pendingCourse._itemId, pendingCourse)
      }
    })
    
    const mergedCourses = approvedCourses.map(approvedCourse => {
      const pendingCourse = pendingMap.get(approvedCourse.id)
      
      if (pendingCourse && pendingCourse._pendingFields) {
        const merged = { ...approvedCourse }
        
        Object.keys(pendingCourse._pendingFields).forEach(fieldName => {
          merged[fieldName] = pendingCourse._pendingFields[fieldName].value
        })
        
        merged._hasPendingChanges = true
        merged._pendingFields = pendingCourse._pendingFields
        
        return merged
      }
      
      return approvedCourse
    })
    
    const newPendingCourses = pendingCourses.filter(p => 
      p._isNew || (p.id && p.id.startsWith('temp-'))
    )
    
    const allCourses = [...mergedCourses, ...newPendingCourses]
    
    allCourses.map((data, index) => {
      let formName = 'course_' + index
      const formattedDescription = Array.isArray(data?.description)
        ? data.description.map(item => `${item}`).join('\n')
        : data?.description
      form.setFieldsValue({
        [formName]: {
          id: data?.id,
          temp_id: data?.temp_id,
          organization: data?.organization,
          organizationId: data?.organizationId,
          title: data?.title,
          started_in: data?.started_in,
          ended_in: data?.ended_in,
          industry: data?.industry,
          description: formattedDescription,
          skill_set: data?.skill_set,
          certificate: data?.certificate,
          awards: data?.awards,
          isDelete: false,
        },
      })

      return courseList.push({
        component: CourseForm,
        formName: formName,
        pendingFields: data._pendingFields || {},
        frozenFields: frozenFieldsMap[data.id] || {},
        _requestId: data._requestId || null
      })
    })
    setCourse(courseList)
  }, [studentFormData, pendingData, frozenFieldsMap])

  const courseHandler = (isAdd, isDelete, deleteForm) => {
    const experienceKeys = Object.keys(form.getFieldValue())

    let lastValue = 0
    for (let i = experienceKeys.length - 1; i >= 0; i--) {
      const key = experienceKeys[i]
      const intValue = parseInt(key.split('_')[1])
      if (!isNaN(intValue)) {
        lastValue = intValue
        break
      }
    }
    let arr = []
    let formName = 'course_' + `${lastValue + 1}`

    arr.push({ 
        component: CourseForm, 
        formName: formName,
      })
    if (isAdd) {
      setIsUpdateButtonEnabled(false)
      return setCourse([...course, ...arr])
    }
    if (isDelete) {
      form.setFieldValue([[deleteForm], 'isDelete'], true)
      setIsUpdateButtonEnabled(false)
      let updatedList = course?.filter(data => data?.formName !== deleteForm)
      return setCourse(updatedList)
    }
  }
  const uuidRegex =
    /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i
  const submitHandler = async () => {
    let course = []
    const values = await form.getFieldValue()
    const errorList = []
    await form
      .validateFields()
      .then()
      .catch(err => {
        errorList.push(err?.errorFields)
      })
    if (!errorList?.length) {
      Object.entries(values).forEach(([name, obj]) => {
        if (
          name.includes('course') &&
          !name.includes('award') &&
          !obj?.isDelete
        ) {
          course.push({
            ...obj,
            awards: [],
          })
        }
      })

      let awardInternData = []
      Object.entries(course).forEach((data, index) => {
        Object.entries(values).forEach(([name, obj]) => {
          if (name.includes('course_' + index + 'award')) {
            let load = {
              [index]: obj,
            }
            awardInternData.push(load)
          }
        })
      })

      for (let i = 0; i < course.length; i++) {
        for (const [key, value] of Object.entries(awardInternData)) {
          for (const [key1, value1] of Object.entries(value)) {
            if (key1 == i) {
              course[i].awards.push(value1)
            }
          }
        }
      }
      course = course.map(proj => ({
        ...proj,
        skill_set: proj.skill_set
          ? proj.skill_set.map(skill => ({
              id: uuidRegex.test(skill.id) ? skill.id : '',
              name: skill.name,
            }))
          : [],
      }))
      let payload = {
        refreshRanking: true,
        admin: {
          ...studentFormData?.admin,
          countryCode: studentFormData?.admin?.countryCode,
        },
        student: studentFormData?.student,
        degreeStreamMap: !studentFormData?.student?.isExpCandidate
          ? {
              degreeId: studentFormData?.currentCourse?.degreeId,
              streamId: studentFormData?.currentCourse?.streamId,
            }
          : {},
        studentPersonalProfile: studentFormData?.studentPersonalProfile,
        currentCourse: !studentFormData?.student?.isExpCandidate
        ? {
            ...studentFormData?.currentCourse,
            marks: studentFormData?.currentCourse?.marks ?? 0,
          }
        : {},
        education: studentFormData?.education,
        // education: studentFormData?.education.map((educationItem) => ({
        //   ...educationItem,
        //   organizationId: organizationId, // Add the organizationId property
        // })),
        resume: {
          ...studentFormData?.resume,
          courses: course,
        },
        checkForApproval: true,
        checkDeleteSection: ['courses'],
      }
      if (payload?.currentCourse?.specialisationId === null) {
        delete payload?.currentCourse?.specialisationId
      }
      if (payload?.studentPersonalProfile?.secondaryEmail === null) {
        delete payload?.studentPersonalProfile?.secondaryEmail
      }
      if (payload?.studentPersonalProfile?.registraionNo === null) {
        delete payload?.studentPersonalProfile?.registraionNo
      }
      studentFormData?.education.map((item, index) => {
        if (item?.skills === null) delete payload?.education[index]?.skills
        if (item?.degreeStreamMapId === null)
          delete payload?.education[index]?.degreeStreamMapId
      })
      payload?.resume?.courses.map((item, index) => {
        if (
          item?.certificate == null ||
          Object.keys(item?.certificate)?.length === 0
        ) {
          delete payload?.resume?.courses[index]?.certificate
        }

        delete payload?.resume?.courses[index]?.startMonth
        delete payload?.resume?.courses[index]?.startYear
        delete payload?.resume?.courses[index]?.endMonth
        delete payload?.resume?.courses[index]?.endYear
      })
      if (payload?.currentCourse?.degreeStreamMapId === null) {
        delete payload?.currentCourse?.degreeStreamMapId
      }
      
      setSubmitLoading(true)
      
      const response = await updateStudentData(payload)
      await dispatch(setResumeData(payload))
      
      dispatch(getStudentData()).catch(err => console.error('getStudentData error:', err))
      if (getPendingData) {
        getPendingData().catch(err => console.error('getPendingData error:', err))
      }
      
      setSubmitLoading(false)
      
      if (response?.success === true) {
        SuccessMessage('Course sent for Approval!')
        setdrawerStatus(false)
        setUpdated(true)
        if (roleDrawer) setRoleDrawer(true)
        if (setExpDrawer) {
          setExpDrawer(true)
        }
        if (getEligibleDetails) {
          getEligibleDetails({ roleID: itemId, setLoading })
        }
        if (getRoleFloatDetails) {
          getRoleFloatDetails({ setLoading })
        }
      } else {
        ErrorMessage(response?.response?.data?.message)
      }
    } else {
      const errorForms = []

      errorList.map(item => {
        item.map(innerItem => {
          if (!errorForms.includes(innerItem?.name[0][0])) {
            errorForms.push(innerItem?.name[0][0])
          }
        })
      })
      const updatedValues = {}
      Object.keys(values).forEach(key => {
        if (errorForms.includes(key)) {
          updatedValues[key] = {
            ...values[key],
            shown: true,
          }
        } else {
          updatedValues[key] = {
            ...values[key],
          }
        }
      })

      form.setFieldsValue(updatedValues)
      setShown(errorForms)
      setSubmitLoading(false)
    }
  }

  const content = () => {
    return (
      <>
        <Form
          scrollToFirstError
          onFinish={submitHandler && !updated}
          id={'courseForm'}
          form={form}
          layout="vertical"
        >
          {!!course.length &&
            course.map((obj, index) => {
              return (
                <obj.component
                  key={index + 'course'}
                  form={form}
                  onRemove={courseHandler}
                  formName={obj?.formName}
                  studentFormData={studentFormData}
                  listOfStudentSkills={listOfSkills}
                  getListOfSkills={getListOfSkills}
                  AllCollegeList={AllCollegeList}
                  instituteCampusValue={instituteCampusName}
                  setInstituteCampusName={setInstituteCampusName}
                  setOrganizationId={setOrganizationId}
                  pendingFields={obj.pendingFields}
                  frozenFields={obj.frozenFields}
                  _requestId={obj._requestId}
                  organizationId={organizationId}
                  setIsUpdateButtonEnabled={setIsUpdateButtonEnabled}
                  skillLoading={skillLoading}
                  setSkillLoading={setSkillLoading}
                  listOfSkills={listOfSkills}
                  SkillsAPI={SkillsAPI}
                  shown={shown}
                />
              )
            })}
        </Form>
        <SubHeading1>Note:</SubHeading1>
        <SubHeading1>
          Please fill in all details in the section below to ensure exposure to
          maximum number of corporates
        </SubHeading1>
        <ButtonLocal 
          onClick={() => courseHandler(true, false)}
          disabled={isAddNewFrozen}
          style={{ opacity: isAddNewFrozen ? 0.5 : 1, cursor: isAddNewFrozen ? 'not-allowed' : 'pointer' }}
        >
          <Control alignCenter gap="10px">
            <AdjustIcon>
              <AddIcon />
            </AdjustIcon>
            <Text>Add Certification</Text>
          </Control>
        </ButtonLocal>
        {studentFormData?.resume?.courses?.length > 0 && skillLoading && (
          <SpinWrapper center>
            <Spin />
          </SpinWrapper>
        )}
      </>
    )
  }
  
  const footer = () => {
    return (
      <FooterFlex right>
        <Button.Secondary
          text="Cancel"
          onClick={() => {
            setdrawerStatus(false)
          }}
        />
        <Button.Primary
          form={'courseForm'}
          htmlType="submit"
          onClick={submitHandler}
          text={'Update'}
          disabled={isUpdateButtonEnabled}
          loading={submitLoading}
        />
      </FooterFlex>
    )
  }
  
  return (
    <Modal
      visible={drawerStatus}
      onCancel={() => setdrawerStatus(false)}
      centered
      width="82%"
      footer={footer()}
      maskClosable={false}
      closable={false}
      destroyOnClose={true}
      bodyStyle={{
        padding: '0',
        borderRadius: '10px',
        height: '90vh',
        display: 'flex',
        flexDirection: 'column',
        overflow: 'hidden'
      }}
    >
      <div style={{ height: '100%', display: 'flex', flexDirection: 'column' }}>
        <div
          style={{
            padding: '15px 30px',
            overflowY: 'auto',
            alignSelf: 'stretch',
          }}>
          <FlexWrapRole spaceBetween>
            <div
              style={{
                fontWeight: 600,
                fontSize: '16px',
                lineHeight: '25px',
                color: '#343E59',
              }}
            >
              Certification
            </div>
            <StyledDiv onClick={() => setdrawerStatus(false)}>
              <CrossIconSkill />
            </StyledDiv>
          </FlexWrapRole>
          {content()}
        </div>
       
      </div>
    </Modal>
  )
}
export default CourseTrainingModal;
